import * as PropTypes       from 'prop-types';
import { connect }          from 'react-redux';
import {
    compose,
    withProps,
    withContext,
    lifecycle,
    branch,
    renderComponent
}                           from 'recompose';
import {
    translate,
    translationsCache
}                           from '../../services/TranslationsService';
import { loadTranslations } from './TranslationsActions';

// components
import LoadingAnimation     from '../../components/LoadingAnimation';

const isLoading       = ({ loading }) => loading;
const LoadingRender   = renderComponent(LoadingAnimation);

const mapStateToProps = ({ translationsStore }) => {
    return {
        loading: translationsStore.loading
    };
};

const mapDispatchers = (dispatch) => ({
    loadTranslations() {
        dispatch(loadTranslations());
    }
});

export default compose(
    connect(mapStateToProps, mapDispatchers),
    withProps(() => ({
        translate
    })),
    withContext({
        translate: PropTypes.func.isRequired
    }, () => ({
        translate
    })),
    lifecycle({
        componentWillMount() {
            if (!translationsCache) {
                (this.props as any).loadTranslations();
            }
        }
    }),
    branch(isLoading, LoadingRender)
);



// WEBPACK FOOTER //
// ./src/sections/Translations/index.ts